import { observer } from "mobx-react-lite";
import React, { useContext, useEffect, useState } from "react";
import ReactPlayer from "react-player";
import { RootStoreContext } from "../../app/stores/rootStore";
import { toast } from "react-toastify";

interface IParams {
  url: string;
  isRendered: boolean;
  onRendering?: () => void;
  className?: string;
}

const ProtectedVideo: React.FC<IParams> = ({
  url,
  isRendered,
  onRendering,
  className,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadProtectedImageOrVideo } = rootStore.meetingStore;
  const [srcData, setSrcData] = useState("");

  useEffect(() => {
    let isMounted = true;

    loadProtectedImageOrVideo(url).then((res) => {
      if (res && res.data) {
        let file = new File([res!.data], "video", { type: "video/mp4" });
        
        let src = window.URL.createObjectURL(file);

        if (isRendered && onRendering) onRendering();

        if (isMounted) setSrcData(src);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [url, loadProtectedImageOrVideo, isRendered, onRendering]);

  return (
    <>
      <div className={className}>
        <ReactPlayer
          url={srcData}
          playing={false}
          controls
          width="100%"
          height="100%"
        />
      </div>
    </>
  );
};

export default observer(ProtectedVideo);
